<template>
 <div v-if="layout">
    <!-- Q1, Q3, Q5 LAYOUT -->
    <v-container v-if="displayLayout == layout.displayLayouts.K || displayLayout == layout.displayLayouts.J" grid-list-md>
      <answers-row
        v-for="(row, index) in myRows"
        :row="row"
        :qId="qId"
        :answers="myAnswer[0]"
        :qColumns="qColumns"
        :key="index"
        :myRows="myRows"
        :displayLayout="displayLayout"
        :displayLayouts="layout.displayLayouts"
				:hasExp="hasExp"
        v-on:update="onUpdateAnswer"
      ></answers-row>
      <div v-if="Boolean(crossCheck)" class="cCheck">
        <v-layout >
          <v-flex class="left-label" xs3><i>{{crossCheck.label}}</i></v-flex>
          <v-flex
            class="tb-width"
            v-for="(reference, index) in crossCheck.references"
            :key="index"
            xs1>
            <ref-cell :reference="reference"></ref-cell>
          </v-flex>
        </v-layout>
      </div>
    </v-container>

    <!-- Q2 (DOUBLE COMMENT BOX) LAYOUT -->
		<v-container v-else-if="displayLayout == layout.displayLayouts.E" grid-list-md>
			<!--<v-layout >
				<v-checkbox v-model="q2disable"></v-checkbox>&nbsp;
				<p style="margin-top:25px;">If your agency's report to OMB is not available to you, check this box to enter N/A in the data fields<span>&#x2e;</span></p>
			</v-layout>-->
			<div v-for="(row, index) in myRows" :key="index" >
				<v-layout >
					<v-flex xs12>
						<header-cell
							:isSub="false"
							:header="row.header"
							:label="row.label"
							:question="row.question"
							:question-id="row.questionId"
							:answer-id="row.answerId"
							:cell-id="row.cellId"
							:help="row.help">
						</header-cell>
					</v-flex>
				</v-layout>

				<v-layout v-for="(sub, index2) in row.subs" :key="index2" >
					<v-flex :style="{'margin-top':'5px'}" xs5>
						<header-cell
							:isSub="true"
							:header="sub.header"
							:label="sub.label"
							:question="sub.question"
							:question-id="sub.questionId"
							:answer-id="sub.answerId"
							:cell-id="sub.cellId">
						</header-cell>
					</v-flex>
					<v-flex xs1>
						<value-cell
              class="tb-width"
							v-if="index2 == 1"
							:has-outline="hasOutline"
							:is-read-only="readOnly"
							:index="parseInt(index2)"
							:name="sub.answers[0].answerId"
							prefix="$"
							:value="myAnswer[0][sub.answers[0].answerId]"
							v-on:update="onUpdateAnswer"
							v-on:update:disable="q2disable = true"
							:disabled="q2disable"
              :id="qId"
						></value-cell>
						<computation-cell
              class="tb-width"
							v-if="index2 == 2"
							:id="qId"
							:name="sub.answers[0].answerId"
							:op="myProps[sub.answers[0].answerId + index2.toString()].op"
							:fields="myProps[sub.answers[0].answerId + index2.toString()].fields"
							:value="computeDifference(myProps[sub.answers[0].answerId + '0'].id, sub.answers[0].answerId, myAnswer[0][sub.answers[0].answerId])"
						></computation-cell>
						<ref-cell
            class="tb-width row-align"
							v-if="index2 == 0"
							:id="myProps[sub.answers[0].answerId + index2.toString()].id"
							:field="myProps[sub.answers[0].answerId + index2.toString()].field"
						></ref-cell>
					</v-flex>
				</v-layout>

				<v-flex v-if="index === 0" xs12>
					<p style="margin-left: 75px;">
						Use the space below to explain any differences between rows a.1 and a.2.
					</p>
					<textarea-autosize
						autosize
						class="comment-box"
						v-model="myAnswer[0].expBox1"
						:min-height="200"
						:max-height="400"
					/>
				</v-flex>
				<v-flex v-if="index === 1" xs12>
					<p style="margin-left: 75px;">
						Use the space below to explain any differences between rows b.1 and b.2.
					</p>
					<textarea-autosize
						autosize
						class="comment-box"
						v-model="myAnswer[0].expBox2"
						:min-height="200"
						:max-height="400"
					/>
				</v-flex>
			</div>
		</v-container>

    <!-- Q4 (RADIO BUTTON) LAYOUT -->
    <v-container v-else-if="displayLayout == layout.displayLayouts.F" fluid grid-list-md>
      <v-layout>
        <v-flex class="left-label" xs3></v-flex>
        <v-flex v-for="(header, index) in likertScaleHeaders" :key="index" class="tb-width" xs1>
          <p class="radio-row-label">{{ header.label }}</p>
        </v-flex>
      </v-layout>

      <v-layout v-for="(row, index) in myRows" :key="index" >
        <v-flex class="left-label" xs3>
          <p class="row-label">{{ row.header }} {{ row.label }}</p>
        </v-flex>
        <v-radio-group v-model="myAnswer[0][row.answers[0].answerId]" row>
          <v-flex class="tb-width" v-for="(header, index) in likertScaleHeaders" :key="index" xs1>
            <v-radio class="radio-button" on-icon="radio_button_checked" off-icon="radio_button_unchecked" :value="header.value"></v-radio>
          </v-flex>
        </v-radio-group>
      </v-layout>
    </v-container>

    <!-- Q6, Q15 LAYOUT -->
    <v-container v-else-if="displayLayout == layout.displayLayouts.D" grid-list-md>
     <answers-row
        v-for="(row, index) in myRows"
        :row="row"
        :qId="qId"
        :answers="myAnswer[0][row.header]"
        :qColumns="qColumns"
        :key="index"
        :myRows="myRows"
        :fullAnswer="myAnswer[0]"
        :displayLayout="displayLayout"
        :displayLayouts="layout.displayLayouts"
				:hasExp="hasExp"
        v-on:update="onUpdateAnswer"
      >
		</answers-row>
      <div v-if="Boolean(crossCheck)" class="cCheck">
        <v-layout >
          <v-flex class="left-label" xs3><i>{{crossCheck.label}}</i></v-flex>
          <v-flex
            class="tb-width"
            v-for="(reference, index) in crossCheck.references"
            :key="index"
            xs1
          >
            <ref-cell :reference="reference"></ref-cell>
          </v-flex>
        </v-layout>
      </div>
    </v-container>

    <!-- Q7, Q10 LAYOUT -->
    <v-container v-else-if="displayLayout == layout.displayLayouts.B" grid-list-md>
      <answers-row
        v-for="(row, index) in myRows"
        :row="row"
        :qId="qId"
        :answers="myAnswer[0]"
        :qColumns="qColumns"
        :key="index"
        :myRows="myRows"
        :displayLayout="displayLayout"
        :displayLayouts="layout.displayLayouts"
				:hasExp="hasExp"
        v-on:update="onUpdateAnswer"
      ></answers-row>
      <div v-if="Boolean(crossCheck)" class="cCheck">
        <v-layout >
          <v-flex class="left-label" xs3><i>{{crossCheck.label}}</i></v-flex>
          <v-flex
            class="tb-width"
            v-for="(reference, index) in crossCheck.references"
            :key="index"
            xs1>
            <ref-cell :reference="reference"></ref-cell>
          </v-flex>
        </v-layout>
      </div>
    </v-container>

     <!-- Q8, Q9, LAYOUT -->
    <v-container v-else-if="displayLayout == layout.displayLayouts.B || displayLayout == layout.displayLayouts.G" grid-list-md>
      <answers-row
        v-for="(row, index) in myRows"
        :row="row"
        :qId="qId"
        :answers="myAnswer[0]"
        :qColumns="qColumns"
        :key="index"
        :myRows="myRows"
        :displayLayout="displayLayout"
        :displayLayouts="layout.displayLayouts"
				:hasExp="hasExp"
        v-on:update="onUpdateAnswer"
      ></answers-row>
      <div v-if="Boolean(crossCheck)" class="cCheck">
        <v-layout >
          <v-flex class="left-label" xs3><i>{{crossCheck.label}}</i></v-flex>
          <v-flex
            class="tb-width"
            v-for="(reference, index) in crossCheck.references"
            :key="index"
            xs1>
            <ref-cell :reference="reference"></ref-cell>
          </v-flex>
        </v-layout>
      </div>
    </v-container>

    <!-- A: {Q11}- NON-DOD and A:{Q12} -DOD -->
    <v-container v-else-if="displayLayout == layout.displayLayouts.A" :v-on="getMyHeight()" grid-list-md>
      <answers-row
        v-for="(row, index) in myRows"
        :row="row"
        :qId="qId"
        :answers="myAnswer[index]"
        :qColumns="qColumns"
        :key="index"
        :myRows="myRows"
        :fullAnswer="null"
        :displayLayout="displayLayout"
        :displayLayouts="layout.displayLayouts"
				:hasExp="hasExp"
        v-on:update="onUpdateAnswer"
      ></answers-row>
      <div v-if="Boolean(crossCheck)" class="cCheck">
        <v-layout >
          <v-flex class="left-label" xs3><i>{{crossCheck.label}}</i></v-flex>
          <v-flex class="tb-width" v-for="(reference, index) in crossCheck.references" :key="index" xs1>
            <ref-cell :reference="reference"></ref-cell>
          </v-flex>
        </v-layout>
      </div>
    </v-container>

    <!--N: NON-DOD{Q12, Q13, DOD -13,14,15} LAYOUT -->
    <v-container v-else-if="displayLayout == layout.displayLayouts.N" :v-on="getMyHeight()" grid-list-md>
			<answers-row
        v-for="(row, index) in myRows"
        :row="row"
        :qId="qId"
        :answers="myAnswer[index]"
        :qColumns="qColumns"
        :key="index"
        :myRows="myRows"
        :fullAnswer="null"
        :displayLayout="displayLayout"
        :displayLayouts="layout.displayLayouts"
				:hasExp="hasExp"
        v-on:update="onUpdateAnswer"
      ></answers-row>
      <div v-if="Boolean(crossCheck)" class="cCheck">
        <v-layout>
          <v-flex class="left-label" xs3><i>{{crossCheck.label}}</i></v-flex>
          <v-flex class="tb-width" v-for="(reference, index) in crossCheck.references" :key="index" xs1>
            <ref-cell :reference="reference"></ref-cell>
          </v-flex>
        </v-layout>
      </div>
    </v-container>

		<!--C: NON-DOD{Q16, Q17, DOD -18,19} LAYOUT -->
    <v-container v-else-if="displayLayout == layout.displayLayouts.C" :v-on="getMyHeight()" grid-list-md>
			<answers-row
        v-for="(row, index) in myRows"
        :row="row"
        :qId="qId"
        :answers="myAnswer[index]"
        :qColumns="qColumns"
        :key="index"
        :myRows="myRows"
        :fullAnswer="null"
        :displayLayout="displayLayout"
        :displayLayouts="layout.displayLayouts"
				:hasExp="hasExp"
        v-on:update="onUpdateAnswer"
      ></answers-row>
      <div v-if="Boolean(crossCheck)" class="cCheck">
        <v-layout>
          <v-flex class="left-label" xs3><i>{{crossCheck.label}}</i></v-flex>
          <v-flex class="tb-width" v-for="(reference, index) in crossCheck.references" :key="index" xs1>
            <ref-cell :reference="reference"></ref-cell>
          </v-flex>
        </v-layout>
      </div>
    </v-container>

		<!--Q20 NonDOD Layout-->
		<v-container v-else-if="displayLayout == layout.displayLayouts.M" grid-list-md>
			<answers-row
        v-for="(row, index) in myRows"
        :row="row"
        :qId="qId"
        :answers="myAnswer[0]"
        :qColumns="qColumns"
        :key="index"
        :myRows="myRows"
        :displayLayout="displayLayout"
        :displayLayouts="layout.displayLayouts"
				:hasExp="hasExp"
        v-on:update="onUpdateAnswer"
      ></answers-row>
		</v-container>

		<!--J: {Q2} LAYOUT -->
    <v-container v-else-if="displayLayout == layout.displayLayouts.L" grid-list-md>
      <answers-row
        v-for="(row, index) in myRows"
        :row="row"
        :qId="qId"
        :answers="myAnswer[index]"
        :qColumns="qColumns"
        :key="index"
        :myRows="myRows"
        :fullAnswer="null"
        :displayLayout="displayLayout"
        :displayLayouts="layout.displayLayouts"
				:hasExp="hasExp"
        v-on:update="onUpdateAnswer"
      ></answers-row>
      <div v-if="Boolean(crossCheck)" class="cCheck">
        <v-layout >
          <v-flex class="left-label" xs3><i>{{crossCheck.label}}</i></v-flex>
          <v-flex class="tb-width" v-for="(reference, index) in crossCheck.references" :key="index" xs1>
            <ref-cell :reference="reference"></ref-cell>
          </v-flex>
        </v-layout>
      </div>
    </v-container>

    <v-container v-else-if="displayLayout === layout.displayLayouts.H" fluid>

        <!-- ========================= -->
        <!-- SECTION 1 — MAIN HEADER -->
      <!-- ========================= -->
      <header-cell v-bind="myRows[0]" />

      <!-- ========================= -->
      <!-- SECTION 1 — INPUTS -->
      <!-- ========================= -->
      <v-row class="mt-4" dense>
        <v-col cols="4">
          <v-text-field
            dense
            hide-details
            class="small-input"
            v-model="answers16or14.con0"
            prefix="$"
            @input="recalculateAllTotals()"
          />
        </v-col>

        <v-col cols="4">
          <v-text-field
            dense
            hide-details
            class="small-input"
            v-model="answers16or14.pla0"
            prefix="$"
            @input="recalculateAllTotals()"
          />
        </v-col>

        <v-col cols="4">
          <v-text-field
            dense
            hide-details
            class="small-input"
            v-model="answers16or14.tot0"
            prefix="$"
            readonly
          />
        </v-col>
      </v-row>

      <!-- ========================= -->
      <!-- SECTION 2 — COUNTRY HEADER -->
      <!-- ========================= -->
      <header-cell v-bind="myRows[1]" class="mt-6" />

      <!-- ========================= -->
      <!-- SECTION 2 — ADD COUNTRIES -->
      <!-- ========================= -->
      <v-row class="mt-2">
        <v-col cols="6">
          <v-select
            v-model="selectedCountriesList"
            :items="countriesList"
            item-text="countryName"
            item-value="countryId"
            multiple
            chips
            label="Select Countries"
            dense
            hide-details
          />
        </v-col>

        <v-col cols="3">
          <v-btn
            small
            color="primary"
            dark
            :class="isSurveyLocked"
            @click="isSurveyLocked == null && onAddingCountries()"
          >
            Add
          </v-btn>
        </v-col>

        <v-col cols="12">
          <span style="color: blue;">{{ countriesMessages }}</span>
        </v-col>
      </v-row>

      <!-- ========================= -->
      <!-- SECTION 2 — INLINE EDIT TABLE -->
      <!-- ========================= -->
      <v-data-table
          class="mt-4"
          dense
          :headers="countriesSelectionHeaders"
          :items="countries"
        >
          <template #item.con="{ item }">
            <v-text-field
              dense
              hide-details
              class="small-input"
              v-model="item.con"
              prefix="$"
              @input="item.con = clean(item.con); recalculateAllTotals()"
            />
          </template>

          <template #item.pla="{ item }">
            <v-text-field
              dense
              hide-details
              class="small-input"
              v-model="item.pla"
              prefix="$"
              @input="item.pla = clean(item.pla); recalculateAllTotals()"
            />
          </template>

          <template #item.tot="{ item }">
            <v-text-field
              dense
              hide-details
              class="small-input"
              v-model="item.tot"
              prefix="$"
              readonly
            />
          </template>
        </v-data-table>

      <!-- ========================= -->
      <!-- SECTION 3 — TOTAL HEADER -->
      <!-- ========================= -->
      <header-cell v-bind="myRows[2]" class="mt-6" />

      <!-- ========================= -->
      <!-- SECTION 3 — TOTALS -->
      <!-- ========================= -->
      <v-row class="mt-2" dense>
        <v-col cols="4">
          <v-text-field dense hide-details class="small-input" v-model="answers16or14.con1" prefix="$" readonly />
        </v-col>

        <v-col cols="4">
          <v-text-field dense hide-details class="small-input" v-model="answers16or14.pla1" prefix="$" readonly />
        </v-col>

        <v-col cols="4">
          <v-text-field dense hide-details class="small-input" v-model="answers16or14.tot1" prefix="$" readonly />
        </v-col>
      </v-row>

      <!-- ========================= -->
      <!-- CROSS CHECK (Grid Style) -->
      <!-- ========================= -->
      <div v-if="Boolean(crossCheck)" class="cCheck">
          <v-layout >
            <v-flex class="left-label" xs3><i>{{crossCheck.label}}</i></v-flex>
            <v-flex class="tb-width" v-for="(reference, index) in crossCheck.references" :key="index" xs1>
              <ref-cell :reference="reference"></ref-cell>
            </v-flex>
          </v-layout>
        </div>
        <br/>
        <div>
          <v-list dense v-if="validationItems.length">
            <v-list-item
              v-for="(item, index) in validationItems"
              :key="index"
              class="py-1"
            >
              <v-list-item-content>
                <v-list-item-title style="text-align:right;color:red;">
                  {{ index + 1 }}. {{ item.title }} {{ item.message }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </div>
      <!-- ========================= -->
      <!-- EXPLANATION -->
      <!-- ========================= -->
      <div class="mt-6">
        <div>If needed, provide clarification below.</div>

        <textarea-autosize
          class="comment-box"
          v-model="answers16or14.explanation"
          :min-height="200"
          :max-height="400"
        />
      </div>

      <!-- ========================= -->
      <!-- ONE CLICK SAVE -->
      <!-- ========================= -->
      <v-row class="mt-4">
        <v-col cols="12" class="left_button">
          <v-btn
            small
            color="primary"
            dark
            :class="isSurveyLocked"
            @click="isSurveyLocked == null && onSaveClick()"
          >
            Save
          </v-btn>

          <span v-if="isSurveyLocked != null" style="color: blue;">
            Survey has been submitted and locked.
          </span>

          <b v-if="errors.column1" style="color: red;">
            {{ errors.column1 }}
          </b>
        </v-col>
      </v-row>
    </v-container>

    <!-- Q18 LAYOUT -->
	<v-container v-else-if="displayLayout == layout.displayLayouts.I"  grid-list-md>
			<div v-if="loading">
				<v-progress-linear
					indeterminate
					color="blue"
				></v-progress-linear>
			</div>
			<answers-row
				v-if="!loading"
        v-for="(row, index) in myDynamicRows"
				:key="row.id || index"
        :row="row"
        :qId="qId"
        :answers="myAnswer[index + 1]"
				:qColumns="qColumns"
        :myRows="myDynamicRows"
        :fullAnswer="null"
        :isDynamic="true"
        v-on:update="onUpdateAnswer"
        :displayLayout="displayLayout"
        :displayLayouts="layout.displayLayouts"
				:hasExp="hasExp"
      />
		<answers-row
				:key="0"
        :row="myRows[0]"
        :qId="qId"
        :answers="myAnswer[0]"
				:qColumns="qColumns"
        :myRows="myRows"
        :fullAnswerArray="myAnswer"
        v-on:update="onUpdateAnswer"
        :displayLayout="displayLayout"
        :displayLayouts="layout.displayLayouts"
				:hasExp="hasExp"
				v-on:update:disable="iLayoutDisable = true;"
				:isNA="iLayoutDisable"
      />

      <div v-if="Boolean(crossCheck)" class="cCheck">
        <v-layout >
          <v-flex class="left-label" xs3><i>{{crossCheck.label}}</i></v-flex>
          <v-flex
            class="tb-width"
            v-for="(reference, index) in crossCheck.references"
            :key="index"
            xs1
          >
            <ref-cell :reference="reference"></ref-cell>
          </v-flex>
        </v-layout>
      </div>
    </v-container>

  </div>
</template>

<script>
import { answerService } from '../../services/answerService';
import { authTokenService } from '@/services/authTokenService.js';
import { surveyService } from "@/services/surveyService.js";
import { CONSTANTS } from '@/common/constants';
import { lookUpService } from "../../services/lookUpService";
import { errorService } from '../../services/errorService';

export default {
  name: 'AnswerMatrix',
  props: {
    layout: Object,
    qId: String,
    displayErrors: Boolean,
    columns: Array,
    displayLayout: Number,
		crossCheck: Object,
		hasExp: Boolean,
    isStandardSurvey: Boolean
  },
  data: () => ({
    myMatrix: null,
    myAnswer: null,
    myProps: null,
    myColumns: null,
    qColumns: [],
    myRows: null,
    myDynamicRows: [],
    hasOutline: false,
    readOnly: false,
		q2disable: false,
		iLayoutDisable: false,
		checkboxState: false,
		dialog: false,
    likertScaleHeaders: [
      { value: '0', label: 'None or not applicable' },
      { value: '1', label: 'Less than $1 million' },
      { value: '2', label: '$1,000,000 to $9,999,999' },
      { value: '3', label: '$10,000,000 to $49,999,999' },
      { value: '4', label: '$50,000,000 or more' },
      { value: '5', label: 'Not available' }
    ],
		myHeight: Number,
    countriesSelection: [],
    countriesSelectionHeaders: [
      { text: 'Countries', value: 'countryName', class: 'cellclname' },
      { text: 'R&D conduct', value: 'con' },
      { text: 'R&D plant', value: 'pla' },
      { text: 'Total R&D conduct and plant', value: 'tot' }
    ],
    countries: [],
    Message: null,
    headingtitle: null,
    countryName: null,
    con: null,
    pla: null,
    tot: null,
    countryId: null,
    answers16or14: {
      con0: null,
      pla0: null,
      tot0: null,
      con1: null,
      pla1: null,
      tot1: null,
      explanation: null
    },
    errors: {
      column1: null,
      validationMessages: null
    },
    addCountries: {
      selectCountry: null
    },
    countryList: [],
    countriesList: [],
    countriesMessages: null,
    selectedCountriesList: [],
    isSurveyLocked: null,
    cvolume: null,
    show: false
  }),
  computed: {
    answer: function () {
      return this.$store.getters['answersArray'];
		},
		loading: function () {
      return this.$store.getters['isLoading'];
		}
  },
  watch: {
		layout (newVal) {
        if (!newVal) return;

        const { matrix, answer, props, columns, displayLayouts } = this.layout;

        this.myMatrix = matrix;
        this.myRows = matrix.rows && matrix.rows.length ? matrix.rows : matrix;
        this.myAnswer = answer;
        this.myProps = props;
        this.myColumns = columns;

        // Handle Display Layout I
        if (this.displayLayout === displayLayouts.I) {
          const flattened = columns
            .slice(1)
            .flatMap(col => col.labels);

          this.myColumns = flattened;
          this.qColumns = flattened;

          // Wait for DOM before creating dynamic rows
          this.$nextTick(() => {
            answer.slice(1).forEach(item => {
              const { insCon, orgCon, orgCod, stateCode } = item;
              const map = {
                "18": () => this.createNewDynamicRow(insCon, orgCod, stateCode),
                "19": () => this.createNewDynamicRow(orgCon, orgCod, stateCode),
                "20": () => this.createNewDynamicRow(insCon, orgCod, stateCode),
                "21": () => this.createNewDynamicRow(orgCon, orgCod, stateCode)
              };
              if (map[this.qId]) map[this.qId]();
            });
          });
        }

        // Run validation AFTER DOM updates
        this.$nextTick(() => {
          this.countriesError(this.qId);
        });
      },
		myAnswer: {
      deep: true,
      handler (newVal, oldVal) {
        // 1. Auto-update validation
        this.countriesError(this.qId);

        // 2. Only run dynamic row logic for Layout I
        if (this.displayLayout !== this.layout.displayLayouts.I) return;

        if (!Array.isArray(newVal) || !Array.isArray(oldVal)) return;

        const addedRows = newVal.filter((item, index) => oldVal[index] !== item);
        if (addedRows.length !== 1) return;

        const row = addedRows[0];
        if (!row) return;

        const map = {
          "18": () => this.createNewDynamicRow(row.insCon, row.orgCod, row.stateCode),
          "19": () => this.createNewDynamicRow(row.orgCon, row.orgCod, row.stateCode),
          "20": () => this.createNewDynamicRow(row.insCon, row.orgCod, row.stateCode),
          "21": () => this.createNewDynamicRow(row.orgCon, row.orgCod, row.stateCode)
        };

        if (map[this.qId]) map[this.qId]();
      }
    },
    checkboxState: function (newVal, oldVal) {
			if (newVal === true && this.iLayoutDisable === false) {
				this.dialog = true;
			} else if (newVal === false) {
				this.iLayoutDisable = false;
				this.$store.commit('setIsLoading', { isLoading: true });
				this.$emit('update:disable:search', false)
				this.$emit('save');
			} else if (newVal === true && this.iLayoutDisable === true) {
				this.$emit('update:disable:search', true);
			}
		},
    selectedCountries: function (newVal, oldVal) {
			this.values = [];

			this.selectedCountries.forEach(entry => {
				if (entry.countryId !== CONSTANTS.COUNTRY_STATIC_ROW_NAMES.A_ROW && entry.countryId !== CONSTANTS.COUNTRY_STATIC_ROW_NAMES.C_ROW) {
					this.values.push(entry.countryId);
				}
			});
			this.values.sort();
		}
  },
  mounted () {
    this.cvolume = authTokenService.getCurrentVolume();
    this.$store.commit('setIsLoading', { isLoading: false });
    const claims = authTokenService.getClaims();
    const activeId = authTokenService.getActiveSurveyId();
    if (claims.surveyId !== undefined && typeof claims.surveyId === 'string') {
      claims.surveyId = activeId;
    }
    if (this.qId === "16" || this.qId === "14") {
			this.onLoad();
			const me = this;
      me.countriesList = [];
      me.countryList = [];
      lookUpService.loadLookUpCountries('country').then(function (response) {
          if (response && response.data) {
            me.countryList.push(response.data);
            for (var i = 0; i < me.countryList[0].length; i++) {
              me.countriesList.push(me.countryList[0][i]);
            }
          }
        });
			me.countriesError(me.qId);
		}
    this.setIsLocked();
  },
  methods: {
    // -----------------------------
    // CLEAN NUMERIC INPUT
    // -----------------------------
    clean (v) {
      const cleaned = (v || '')
        .toString()
        .replace(/[^0-9.]/g, '')
        .replace(/(\..*)\./g, '$1');

      if (cleaned === '' || cleaned === '.') return 0;
      return Number(cleaned);
    },
    recalculateAllTotals () {
      // Clean main inputs
      const a = this.answers16or14;

      a.con0 = this.clean(a.con0);
      a.pla0 = this.clean(a.pla0);
      a.tot0 = a.con0 + a.pla0;

      // Compute totals from grid
      let conTotal = 0;
      let plaTotal = 0;

      this.countries.forEach(row => {
        const con = this.clean(row.con);
        const pla = this.clean(row.pla);

        conTotal += con;
        plaTotal += pla;

        row.tot = con + pla; // keep grid reactive
      });

      // Assign totals to bottom row
      a.con1 = conTotal + a.con0;
      a.pla1 = plaTotal + a.pla0;
      a.tot1 = a.con1 + a.pla1;
    },
    // -----------------------------
    // ADD COUNTRIES (Vuetify v-select)
    // -----------------------------
    onAddingCountries () {
      const me = this;
      const vqId = this.qId;

      if (!me.selectedCountriesList.length) {
        me.countriesMessages = "No countries selected.";
        return;
      }

      me.countriesMessages = "Processing please wait...";

      const claims = authTokenService.getClaims();
      const activeId = authTokenService.getActiveSurveyId();

      if (typeof claims.surveyId === "string") {
        claims.surveyId = activeId;
      }

      surveyService
        .saveCountries(claims.surveyId, me.selectedCountriesList, claims.userName, vqId)
        .then(() => {
          me.countriesMessages = "Countries added successfully.";
          me.selectedCountriesList = [];

          // DO NOT CLEAR EXISTING ROWS
          // me.countries = [];  <-- removed

          setTimeout(() => {
            me.onLoad();
            me.countriesMessages = "";
          }, 500);
        });
    },
    async onSaveClick () {
        const vqId = this.qId;
        this.errors.column1 = "Processing please wait...";

        if (this.isSurveyLocked != null) {
          this.errors.column1 = "Survey has been submitted and locked.";
          return;
        }

        this.$store.commit("setIsLoading", { isLoading: true });

        const claims = authTokenService.getClaims();
        const activeId = authTokenService.getActiveSurveyId();

        if (typeof claims.surveyId === "string") {
          claims.surveyId = activeId;
        }

        // ⭐ ALWAYS RECALCULATE BEFORE SAVING
        this.recalculateAllTotals();

        let conTotal = 0;
        let plaTotal = 0;

        const answers = [];

        // -----------------------------------------
        // 1. NORMAL COUNTRY ROWS (editable grid rows)
        // -----------------------------------------
        this.countries.forEach(row => {
          const con = this.clean(row.con);
          const pla = this.clean(row.pla);

          conTotal += con;
          plaTotal += pla;

          answers.push({
            countryId: row.countryId,
            countryName: row.countryName,
            con,
            pla,
            tot: con + pla,
            expBox: row.expBox || ""
          });
        });

        // -----------------------------------------
        // 2. SPECIAL ROW 90009 (first row)
        // -----------------------------------------
        const mainCon = this.clean(this.answers16or14.con0);
        const mainPla = this.clean(this.answers16or14.pla0);
        const mainTot = mainCon + mainPla;

        // Add first row to totals
        conTotal += mainCon;
        plaTotal += mainPla;

        answers.push({
          countryId: "90009",
          con: mainCon,
          pla: mainPla,
          tot: mainTot,
          expBox: this.answers16or14.explanation
        });

        // -----------------------------------------
        // 3. TOTAL ROW 91000 (last row)
        // -----------------------------------------
        answers.push({
          countryId: "91000",
          con: conTotal,
          pla: plaTotal,
          tot: conTotal + plaTotal,
          expBox: ""
        });

        // -----------------------------------------
        // SAVE
        // -----------------------------------------
        await answerService.saveAnswer(vqId, answers, true).then(saveResponse => {
          if (saveResponse && saveResponse.status === CONSTANTS.HTTP.NO_CONTENT) {
            this.errors.column1 = "Saved Successfully";
            this.$store.commit("setIsLoading", { isLoading: false });

            setTimeout(() => {
              this.onLoad();
              this.$nextTick(() => this.recalculateAllTotals());
            }, 500);
          }
        });
      },
    // -----------------------------
    // LOAD DATA FROM BACKEND
    // -----------------------------
    onLoad () {
    const me = this;
    const vqId = this.qId;
    const activeSurveyId = authTokenService.getActiveSurveyId();

    answerService.getAvaiableCountries(activeSurveyId, vqId).then(response => {
      if (!response || !response.data) return;

      me.countries = [];

      response.data.forEach(row => {
        if (row.countryId === "90009") {
          // main input row
          me.answers16or14.con0 = row.con;
          me.answers16or14.pla0 = row.pla;
          me.answers16or14.tot0 = row.tot;
          me.answers16or14.explanation = row.expBox;
        } else if (row.countryId === "91000") {
          // totals row
          me.answers16or14.con1 = row.con;
          me.answers16or14.pla1 = row.pla;
          me.answers16or14.tot1 = row.tot;
        } else {
          // normal country rows
          me.countries.push({
            ...row,
            con: row.con,
            pla: row.pla,
            tot: row.tot
          });
        }
      });
      this.$nextTick(() => this.recalculateAllTotals());
    });
    },
    // -----------------------------
  // VALIDATION
  // -----------------------------
    countriesError (vqId) {
      this.$store.dispatch("validation/loadQuestionStatuses");
      this.$store.dispatch("validation/loadSurveyValidationMessages");

      errorService.getValidationMessagesForQuestion(vqId).then(response => {
        const items =
          response &&
          response.data &&
          response.data.validationItems
            ? response.data.validationItems
            : [];

        this.validationItems = items;
      });
    },
    getMyHeight () {
      var height = this.myAnswer.length;
			return height;
    },
    onUpdateAnswer: function (val) {
      this.$emit('update', val);
    },
		onUpdateRows: async function (val) {
      debugger;
			this.$store.commit('setIsLoading', { isLoading: true });
			var currentEntries = [];
			for (let i = 1; i < this.layout.answer.length; i++) {
				currentEntries.push(this.layout.answer[i].countryId);
			}

			for (let i = 0; i < val.searchValues.length; i++) {
				if (currentEntries.findIndex(element => element == val.searchValues[i]) == -1) {
					this.createNewAnswerEntry(val.searchValues[i]);
					this.createNewDynamicRow(val.searchValues[i]);
				}
			}
  this.$emit('save');
    },
	  createNewAnswerEntry: function (idName) {
    var temp = Object.assign({}, this.layout.answer[0]);
      for (var key in temp) {
        if (temp.hasOwnProperty(key)) {
          if (typeof temp[key] === 'number' || typeof temp[key] === 'object') {
            temp[key] = 0;
          } else {
            temp[key] = null;
          }
        }
      }

      temp.status = 'InProgress';
      temp.countryId = idName;
      temp.createDate = '0001-01-01T00:00:00';
      temp.updateDate = '0001-01-01T00:00:00';
      this.myAnswer.push(temp);
    },
    getTotalNumCols () {
      console.log('this.qColumns: ' + JSON.stringify(this.qColumns));
      var numCols = 0;
      var i;
      for (i = 0; i < this.qColumns.length; i++) {
        numCols++;
      }
      console.log('numCols: ' + numCols);
      return numCols;
    },
    createNewDynamicRow: function (rowName, rowCode = "", stateCode = "") {
			debugger; // Ensure layout.answer exists and has at least one row
			if (!this.layout || !this.layout.answer || !this.layout.answer[0]) {
				console.error("Invalid layout.answer structure");
				return;
			} const cellNames = Object.keys(this.layout.answer[0]);
			// Starting index for dynamic row cells
			let cellNameIndx = 4;
			if (this.displayLayout !== this.layout.displayLayouts.I) {
				console.warn("Unexpected layout type for dynamic rows");
			} // Build the new dynamic row
			const qaRow = {
				header: rowCode.toString(),
				label: rowName,
				help: "",
				state: stateCode.toString(),
				answers: []
			};
				// Build answer cells
				this.myColumns.forEach(() => {
					const cellName = cellNames[cellNameIndx];
					if (!cellName) {
						console.error("Cell name index out of range:", cellNameIndx);
						return;
					}
						const cellId = `${cellName} ${this.qId}`;
						qaRow.answers.push({ cellId: cellId, answerId: cellName, questionId: this.qId, question: null });
						cellNameIndx++;
					}); // Add to dynamic rows
					this.myDynamicRows.push(qaRow);
					console.log("Created dynamic row:", qaRow);
		},
    getTotalRows: function (numRows, answer, index2) {
      debugger;
      var i;
      var sum = 0;
      for (i = 0; i < numRows; i++) {
        sum += answer[this.myRows[i][index2].id];
      }
      return sum;
    },
    computeDifference: function (id, name, value) {
      if (value == Number.MIN_SAFE_INTEGER) {
        return Number.MIN_SAFE_INTEGER;
      }
      const ans = this.answer;
      var v;
      if (ans && id) {
        const val = ans[id];
        const value1 = val[0] ? val[0][name] : 0;
        v = value1;
      } else {
        v = answerService.getAnswerValue(0);
      }
      return v - value;
    },
		setIsLocked: function () {
			const me = this;
      me.activeId = authTokenService.getActiveSurveyId();
			surveyService.getLockStatus(me.activeId).then(function (response) {
				if (response && response.data != null) {
					if (response.data.isLocked == true) {
							me.isLocked = true;
              me.isSurveyLocked = "isDisabled";
							me.lockMessage = "This survey has been submitted and locked."
					}	else if (response.data.currentUser != null) {
						me.isLocked = true;
						me.lockMessage = `The survey is in use by user: ${response.data.currentUser}`;
					}	else {
            me.isSurveyLocked = null;
						me.lockMessage = null;
					}
				}
			})
			.catch(function (e) {
				console.log(e);
				console.log('Error loading survey lock status')
				throw e;
			});
     return me.isLocked;
		}
  }
};
</script>

<style scoped>
.isDisabled {
  color: currentColor;
  cursor: not-allowed;
  opacity: 0.5;
  text-decoration: none;
}
h2 {
  font-size: 12pt;
  margin-left: 25px;
}
.left_button {
  text-align: left;
}
.row-label-head {
  font-weight: bold;
  text-align: left;
  margin-top: 10px;
  margin-left: 0px;
}
.row-label {
  font-weight: bold;
  text-align: left;
  margin-top: 10px;
  margin-left: 0;
}
.row-label-sub {
  font-weight: normal;
  text-align: left;
  margin-top: 10px;
}
.row-label-help {
  font-weight: normal;
  text-align: left;
}
.radio-row-label {
  font-weight: bold;
  text-align: center;
}
.radio-button {
  margin-left: 60px;
  text-align: center;
}
.question-content .v-text-field {
  width: 70%;
  margin: 0 auto;
}
.comment-box {
  min-width: 80%;
  background: white;
  margin-bottom: 40px;
}
.left {
  justify-content: left;
}
.tb-width {
  min-width: 150px;
}
.row-align {
  margin-top: 17px;
}
.left-label {
   margin-top: 17px;
   min-width: 450px;
}
.error {
    color: red;
}
select.mySelect{
    background: #20d492;
    color: #fff;
    padding: 0 10px;
    font-size: 12pt;
}
select.mySelect option{
	color: #000;
    padding: 0 10px;
}
</style>
